import { module } from 'modujs';
import { gsap } from 'gsap';
import { textAnimations } from '../utils/text-animations';

export default class extends module {
    constructor(m) {
        super(m);

        this.opened = false;
        this.isLoading = false;
        this.popinContent = this.el.querySelector('.o-popins_content');
        this.pageURL = new URL(window.location);
        this.pageURLFull = this.getPageURLFull();
        
        this.mask = this.el.querySelector('.o-popins_mask');
        this.loading = this.el.querySelector('.o-popins_loading');

        this.currentPopin = null;

        this.onClick = this.onClick.bind(this);

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    init() {
        
        // If hash in URL, clean it and open popin
        let hash = new URL(document.URL).hash;
        let type = 'popin';

        if (hash) {
            let cleanHash = null;

            if (hash.includes('#/menu/', 0)) {
                cleanHash = hash.replace('#/menu/', '');
                type = 'menu';
            } else {
                if (hash.charAt(0) == '#') {
                    cleanHash = hash.slice(1);
                }
                if (cleanHash.charAt(0) == '/') {
                    cleanHash = cleanHash.slice(1);
                }
            }

            if (document.querySelector('[data-scroll-target="' + cleanHash + '"]')) {
                this.call('scrollTo', '[data-scroll-target="' + cleanHash + '"]', 'Scroll');
            } else {
                setTimeout(() => {
                    this.call('stop', 'Scroll');
                    this.load(cleanHash, type);
                }, 1000);
            }
        }

        this.updateListeners();
    }

    updateListeners() {
        let that = this;
        document.querySelectorAll('[data-popin]').forEach((elt) => {
            elt.removeEventListener('click', that.onClick);
            elt.addEventListener('click', that.onClick);
        });   
    }

    onClick(e) {
        e.preventDefault();
                
        let popinId = e.currentTarget.getAttribute('data-popin');
        let type = 'popin';
        if (popinId.includes('menu/', 0)) {
            type = 'menu';
            popinId = popinId.replace('menu/', '');
        }

        if (this.opened && this.currentPopin) {
            this.currentPopin.classList.remove('-visible');
        }

        this.load(popinId, type);
        history.pushState({ urlPath: '#/' + e.currentTarget.getAttribute('data-popin') }, '', this.pageURLFull + '#/' + e.currentTarget.getAttribute('data-popin'));
    }

    load(popinId, type) {
        let xhrUrl = new URL(ajaxVars.url);
        xhrUrl.searchParams.set('action', 'popins_ajax');
        xhrUrl.searchParams.set('popin_id', popinId);
        xhrUrl.searchParams.set('type', type);

        let that = this;
        that.isLoading = true;
        this.loading.classList.add('-visible');

        if (that.opened == false) {
            that.open();
        }

        let xhr = new XMLHttpRequest();
        xhr.open("GET", xhrUrl);
        xhr.send();
        xhr.onload = function(response) {
            if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                let result = xhr.responseText;
                that.isLoading = false;
                that.loading.classList.remove('-visible');

                that.showPopin(result);
            }
        };
    }

    open() {
        this.opened = true;
        this.call('stop', 'Scroll');
        this.el.classList.add('-opened');
        this.mask.classList.add('-visible');
        this.loading.classList.add('-visible');
    }

    close() {
        this.opened = false;
        this.call('start', 'Scroll');
        this.mask.classList.remove('-visible');
        this.loading.classList.remove('-visible');
        history.pushState(null, '', this.getPageURLFull());
        this.hideAndRemovePopin()

        setTimeout(() => {
            this.el.classList.remove('-opened');
            this.popinContent.innerHTML = '';
        }, 1000);
    }

    showPopin(htmlContent){
        if (!htmlContent) {
            this.close();
            this.el.classList.remove('-opened');
            return;
        }
        
        this.popinContent.innerHTML = htmlContent;
        this.currentPopin = this.popinContent.querySelector('.o-popin');

        setTimeout(() => {
            this.currentPopin.classList.add('-visible');
            this.updateEvents();
            this.updateListeners();
        }, 300);
    }

    hideAndRemovePopin() {
        if (this.currentPopin) {
            this.currentPopin.classList.remove('-visible');
        }
    }

    updateEvents() {
        // Update modules & scroll
        // this.call('update', this.el, 'app');
        this.call('addElements', this.popinContent, 'Scroll');
        textAnimations(this.popinContent);

        if (this.popinContent.querySelectorAll(".wpcf7 > form").length > 0) {
            this.popinContent.querySelectorAll(".wpcf7 > form").forEach((
                function(e){
                    return wpcf7.init(e);
                }
            ));
        }
    }

    getPageURLFull() {
        return this.pageURL.origin + this.pageURL.pathname;
    }
}
